module.exports = __webpack_public_path__ + "static/media/19.8e5786e0.jpg";